import React, { useCallback } from "react";
import { PhotoAlbum, PhotoProps } from "react-photo-album";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Lottie from "react-lottie";
import animationData from "../../Assets/coming-soon.json";
import photos from "./photos";
import videos from "./videos";
import slides from "./slides";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Video from "yet-another-react-lightbox/plugins/video";

function Secret() {
  const [index, setIndex] = React.useState(-1);
  const [open, setOpen] = React.useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          The Other <strong className="purple">Me </strong>
        </h1>

        <p style={{ color: "#ffffff" }}>
          I love designing, editing and taking aesthetic photographs. Here are
          some collections.😍
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "2rem",
          }}
        >
          <button
            className="button-75"
            role="button"
            onClick={() => setOpen(true)}
          >
            <span className="text">See My Videos</span>
          </button>
        </div>
        <div sx={{ width: "auto", mx: "auto" }}>
          <PhotoAlbum
            photos={photos}
            layout={"masonry"}
            onClick={(event, photo, index) => setIndex(index)}
          />
        </div>
        <Lightbox
          open={index >= 0}
          close={() => setIndex(-1)}
          index={index}
          slides={slides}
        />

        {/* <Lottie options={defaultOptions} height={400} width={400} /> */}

        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={[...videos, ...slides]}
          plugins={[Video]}
        />
      </Container>
    </Container>
  );
}

export default Secret;
